import { AppState } from '../../app-state/app-state';

export const getSchoolActivityById = (id: number) => (state: AppState) => state.schoolActivities.entities[id];
